import { FC, useState } from "react"

import { StatisticsObjectType } from "./types";
import Modal from "../modal";



const CustomButtonRight: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {
  const [showingModal, setModal] = useState(false);
  const [title, setTitle] = useState("");



  const openModal = (title: string) => {
    if (window.location.pathname.includes("territories")) {
      setTitle(title);
      setModal(true);
      document.body.style.overflow = 'hidden';
    }

  };

  return (
    <>
      <div className="card flex-fill">
        {showingModal ? <Modal title={title} data={title === "New Practices" ? StatisticsObjectType && StatisticsObjectType.new_practices &&  StatisticsObjectType.new_practices.data : StatisticsObjectType && StatisticsObjectType.new_hcps &&  StatisticsObjectType.new_hcps.data} onClick={() => setModal(false)}></Modal> : null}

        <div className="card-header text-center">
          <p className="mb-0 h3 text-primary">New Practices</p>
        </div>
        <div className="card-body text-center">
          <p className="btn-link display-6 fw-semibold text-center mb-0" style={{ lineHeight: 1.5, cursor: "pointer" }}
            onClick={() => { openModal("New Practices") }}>
            {StatisticsObjectType.new_practices.count}
          </p>
        </div>
      </div>

      <div className="card flex-fill">
        <div className="card-header text-center">
          <p className="mb-0 h3 text-primary">
            {window.location.pathname.includes("region") || window.location.pathname.includes("district") ? "New Doctors" : "New HCPs"}
          </p>
        </div>
        <div className="card-body text-center">
          <p className="btn-link display-6 fw-semibold text-center mb-0" style={{ lineHeight: 1.5, cursor: "pointer" }} onClick={() => { openModal("New Doctors") }}>
            {StatisticsObjectType.new_doctors ? StatisticsObjectType.new_doctors.count : StatisticsObjectType.new_hcps.count}
          </p>
        </div>
      </div>

      <div className="card flex-fill">
        <div className="card-header text-center">
          <p className="mb-0 h3 text-primary">New/Existing Pat</p>
        </div>
        <div className="card-body text-center">
          <p className="display-6 fw-semibold text-black text-center mb-0" style={{ lineHeight: 1.5 }}>
            {StatisticsObjectType.new_existing_pat}
          </p>
        </div>
      </div>
    </>
  )
}
export default CustomButtonRight;
